export default "__VITE_ASSET__KDi2Pqg0__"